import { render, staticRenderFns } from "./TopSitesOverPeriod.vue?vue&type=template&id=60aa84ed&"
import script from "./TopSitesOverPeriod.vue?vue&type=script&lang=js&"
export * from "./TopSitesOverPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports